import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
// HTML prerenderizado: se muestra como fallback mientras carga el chunk de la página.
window.__PRERENDER_HTML = rootElement.innerHTML;

// El prerender hornea tags <head> estáticos (data-prerender) para bots sin JS.
// Al montar React los quitamos: react-helmet-async gestiona el head en runtime
// y así no quedan meta tags duplicados.
const listEl = document.getElementById("__BLOG_LIST__");
if (listEl) {
  try { window.__BLOG_LIST__ = JSON.parse(listEl.textContent); } catch {}
}
const postEl = document.getElementById("__BLOG_POST__");
if (postEl) {
  try { window.__BLOG_POST__ = JSON.parse(postEl.textContent); } catch {}
}
document.querySelectorAll("[data-prerender]").forEach((el) => el.remove());

// El prerender hornea solo un shell estático (no markup de React), así que
// siempre montamos con createRoot: React reemplaza el shell al cargar.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    
      <App />
    
  </React.StrictMode>,
);
